module.exports = __webpack_public_path__ + "img/3.d32c5fd7.png";